module.exports = __webpack_public_path__ + "cae5cc3947342e47b0792e50a52fa3bb.svg";